<app-category-hero
  i18n-titleZh="@@contactUs.hero.title" titleZh="聯絡我們"
  i18n-tagline="@@contactUs.hero.tagline" tagline="Contact Us"
  i18n-breadcrumbLabel="@@contactUs.hero.breadcrumb" breadcrumbLabel="聯絡我們"
  bannerImage="assets/image/redesign/choux-hero-banner.jpeg">
</app-category-hero>

<section class="contact-page">
  <div class="contact-page__wrapper">
    <div class="contact-page__info">
      <app-contact-info></app-contact-info>
    </div>
    <div class="contact-page__form">
      <app-contact-form [status]="status" (submitForm)="onSubmit($event)"></app-contact-form>
    </div>
  </div>
</section>
